import React from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { Launch } from "@mui/icons-material";

const OpenInNewTab = ({
  label,
  link,
  className = "",
  disableIcon = false,
  children,
  disableColor = false,
  disableHover = false,
  ...linkProps
}) => {
  if (!label) return "N/A";

  return (
    <Link
      to={link}
      title={`View ${label} in new tab`}
      target="_blank"
      {...linkProps}
      className="group"
    >
      <div
        className={twMerge(
          "inline-flex flex-shrink-0 items-center space-x-2 text-black  dark:text-blue-300",
          !disableColor && "text-blue-600",
          !disableHover && "group-hover:text-blue-600 group-hover:underline"
        )}
      >
        <div className={twMerge("line-clamp-1", className)}>
          {children || label}
        </div>

        {!disableIcon && <Launch fontSize="inherit" />}
      </div>
    </Link>
  );
};

export default OpenInNewTab;
